import * as React from "react";
import type { SVGProps } from "react";
const SvgMap04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="m15.467 8.262-.383.924zm4.55 11.262a1 1 0 1 0 .765-1.848l-.382.924zM3.383 10.476a1 1 0 1 0-.764 1.848L3 11.4zM5.788 2.4v1h12.424v-2H5.788zm12.424 19.2v-1H5.788v2h12.424zM2.4 18.212h1V5.788h-2v12.424zM5.788 21.6v-1A2.39 2.39 0 0 1 3.4 18.212h-2A4.39 4.39 0 0 0 5.788 22.6zM21.6 18.212h-1a2.39 2.39 0 0 1-2.388 2.388v2a4.39 4.39 0 0 0 4.388-4.388zM18.212 2.4v1A2.39 2.39 0 0 1 20.6 5.788h2A4.39 4.39 0 0 0 18.212 1.4zm-12.424 0v-1A4.39 4.39 0 0 0 1.4 5.788h2A2.39 2.39 0 0 1 5.788 3.4zM21.6 10.8h-1v7.412h2V10.8zM4.2 3.6l-.382.924 11.266 4.662.383-.924.382-.924L4.582 2.676zm11.267 4.662-.383.924 6.134 2.538.382-.924.382-.924-6.133-2.538zM18.212 3l-.887-.463L14.58 7.8l.887.462.886.463 2.745-5.262zM20.4 18.6l.382-.924-17.4-7.2L3 11.4l-.382.924 17.4 7.2zm1.2-12.812h-1V10.8h2V5.788z"
    />
  </svg>
);
export default SvgMap04;
